import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'dashboard',
            meta: {
                requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "page-dashboard" */ './views/Dashboard.vue')
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                requiresAuth: true,
                hideToolbar: true,
                vCenter: true
            },
            component: () => import(/* webpackChunkName: "page-login" */ './views/Login.vue')
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "page-about" */ '@/views/About.vue')
        },
        {
            path: '/account',
            name: 'my-account',
            meta: {
                requiresAuth: true
            },
            component: () => import(/* webpackChunkName: "page-account" */ './views/MyAccount.vue')
        },
        // demo pages
        {
            path: '/demo-dash',
            name: 'demo-dash',
            component: () => import(/* webpackChunkName: "page-dashboard" */ './views/Dashboard.vue')
        },
        {
            path: '/demo-account',
            name: 'demo-account',
            component: () => import(/* webpackChunkName: "page-account" */ './views/MyAccount.vue')
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});
export default router;
